/*
 * @Author: mayanxia 
 * @Date: 2020-11-07 19:54:06 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-10-20 10:41:58
 */

<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="$t('发票代码')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="invoiceCode">
              <a-input v-model="model.invoiceCode" :placeholder="$t('请输入发票代码')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('开票人')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="drawer">
              <a-input v-model="model.drawer" :placeholder="$t('请输入开票人')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('开票时间')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="invoiceDate">
              <a-date-picker v-model="model.invoiceDate" showTime style="width: 100%" format="YYYY-MM-DD HH:mm:ss" :placeholder="$t('请输入开票时间')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注信息')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea v-model="model.remark" rows="4" :placeholder="$t('请输入备注信息')"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { postAction,getAction } from '@/api/manage'
  import {queryAreaTreeList} from '@/api/api'
  import pick from 'lodash.pick'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: "MeterPayRecordInvoiceModal",
    components: { ATextarea },
    data () {
      return {
        treeData:[],
        phoneWarning:'',
        title:this.$t("开票信息"),
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {
          invoiceCode: '',
          drawer: '',
          invoiceDate: null
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/payRecordInvoice/addByPayRecordId"
        },
        payRecordId: ''
      }
    },
    created () {
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      rules() {
        return {
          //areaId:[{ required: true, message: '请输入区域编码!'}],
          invoiceCode: [{required: true, message: this.$t('请输入发票代码!')}],
          drawer: [{required: true, message: this.$t('请输入开票人!')}],
          invoiceDate: [{required: true, message: this.$t('请输入开票日期!')}],
        }
      },
    },
    methods: {
      add (depart) {
        if(depart){
          this.seen = false;
        }else{
          this.seen = true;
        }
        this.edit(depart);
      },
      edit (record) {
        this.treeData = []
        this.model = Object.assign(this.model, {});
        this.visible = true;
        this.$nextTick(() => {
          this.$refs.formModal.resetFields();
          this.payRecordId = record.id;
        })
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            this.model.invoiceDate = this.model.invoiceDate.format('YYYY-MM-DD HH:mm:ss')
            postAction(this.url.add+'/'+this.payRecordId,this.model).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style scoped>

</style>